import CalendarLocale from 'bonree-picker/lib/locale/en_US';
import TimePickerLocale from '../../time-picker/locale/en_US';
// Merge into a locale object
const locale = {
    lang: Object.assign({ placeholder: 'Select date', yearPlaceholder: 'Select year', quarterPlaceholder: 'Select quarter', monthPlaceholder: 'Select month', weekPlaceholder: 'Select week', rangePlaceholder: ['Start date', 'End date'], rangeYearPlaceholder: ['Start year', 'End year'], rangeMonthPlaceholder: ['Start month', 'End month'], rangeWeekPlaceholder: ['Start week', 'End week'] }, CalendarLocale),
    timePickerLocale: Object.assign({}, TimePickerLocale),
    globalPickerLocale: {
        last5minutes: 'Last 5 minutes',
        last10minutes: 'Last 10 minutes',
        last30minutes: 'Last 30 minutes',
        last1hour: 'Last 1 hour',
        last3hours: 'Last 3 hours',
        last6hours: 'Last 6 hours',
        last12hours: 'Last 12 hours',
        last24hours: 'Last 24 hours',
        last2days: 'Last 2 days',
        last3days: 'Last 3 days',
        last7days: 'Last 7 days',
        last15days: 'Last 15 days',
        last30days: 'Last 30 days',
        last90days: 'Last 90 days',
        last6months: 'Last 6 months',
        last1year: 'Last 1 year',
        today: 'Today',
        yesterday: 'Yesterday',
        thisDayLastWeek: 'This day last week',
        thisWeek: 'This week',
        previousWeek: 'Previous week',
        thisMonth: 'This month',
        previousMonth: 'Previous month',
        thisYear: 'This year',
        previousYear: 'Previous year',
        year: 'Y',
        month: 'M',
        day: 'd',
        hour: 'h',
        minute: 'm',
        minutes: 'minutes',
        second: 's',
        noRefresh: 'No Refresh',
        noRecord: 'No record',
        timeRange: 'Selected time range',
        invalidTimeRange: 'Time range cannot be estimated',
        preTimeRange: 'Forward time range',
        nextTimeRange: 'Future time range',
        noFuture: 'Cannot reach the time when it did not occur',
        noGreater: "Time range can't be greater than",
        noEqual: 'Start time must be before end time',
        shortcut: 'Shortcut',
        custom: 'Custom',
        recentlyUsed: 'Recently used',
        viewHelp: 'If you need help, please click the icon on the right to view guide!',
        guide: 'Timeframe selector guide',
        tutorialsContent: `To define a timeframe, provide a start point and an endpoint in time, connected with tilde ~. If you provide only a single point in time, it will be treated as the start point. The endpoint is assumed to be now by default. The point in time which now represents will be updated with the refresh frequency you choose
    For the input of time range, both absolute time range and relative time range are supported. The introductions and examples for both forms are as follows.`,
        absoluteTime: 'Absolute time range',
        absoluteTimeContent: `The exact time values of the date & time, such as 2020-05-14 00:00:00 ~ 2020-05-15 23:59:59
    Supported absolute date/time format: YYYY-MM-DD hh:mm:ss
    While it's time-only value ranges or if part of the date is missing. Fill the missing part of the date relative to today. While it's reduced accuracy shortcut inputs, fill the missing part with the start time of the input.
    Example syntax(Suppose now is 2021-05-25 11:02:45):
    ● 2020 14:34 ~ 13:45
    Means the same as 2020-05-25 14:34:00 to 2021-05-25 13:45:00. Time-only value ranges or part of the date is missing, Fill the missing part of the date relative to today.
    ● 2021 and 2021-04 as well as 2021-04-03
    Means the same as 2021-01-01 00:00:00 till now（2021-05-25 11:02:45）, 2021-04-01 00:00:00 till now, 2021-04-03 00:00:00 till now. Reduced accuracy shortcuts, fill the missing part with the start time value.`,
        relativeTime: 'Relative time range',
        relativeTimeConent: `Date/time always related to present time point ( now), such us one week before & 1h30min before.
    Supported units: s,m,h,d,w,M,y.
    Supported relative-time keywords: now.
    Supported operators: -，/<unit>.
    You can use math operators +or-on keywords to help define time. And use the format /<unit> on the nowkeyword or in relative expressions to round down the date or time to the beginning of the specified time unit. For instance, now/d rounds down to the beginning of today and -1M/M rounds down to the beginning of the previous month.
    Now you can define a relative date with a fixed time by using these keywords and operators.
    Example syntax(Suppose now is 2021-05-25 11:02:45):
    ● -1w ~ now
    Means the same as 2021-05-18 11:02:45 till now（2021-05-25 11:02:45. One week ago till now.
    ● -1M ~ -1h29m
    Means the same as 2021-04-25 11:02:45 to 2021-05-25 09:33:45. One month ago from now to 1h29min ago. Now can be omitted when it's at the start.
    ● -3d/d and now/d as well as -1M/w
    Means the same as  2021-05-22 00:00:00 till now, 2021-05-25 00:00:00 till now and 2021-04-19 00:00:00 till now. From the beginning of the day three days ago to now，the beginning of today to now and the beginning of the week one month ago to now.
    ● -1d/d ~ now - 7h2m45s
    Means the same as 2021-05-24 00:00:00 to 2021-05-25 04:00:00.
    Customize a flexible relative time range through operators.`,
        liveTail: 'Live Tail',
        liveTailContent: 'View all log data accessed in real time',
        recent: 'Recent',
        relative: 'Relative',
        special: 'Special',
        current: 'Current ',
        previousDay: 'Previous ',
        previousWeekDay: 'Last week on the same ',
        last: 'Last ',
        lastWeek: 'Last week on same ',
        specialDate: `Special Date`,
        specialDateConent: `The time component supports special date (non natural day) options, such as trading days, working days, etc., which need to be set in the account settings center. After setting, you will see the relevant options in the time component. The special date options are described as follows：
    ● Current Special Date: Query data within the current day range. If the current day is a non special date, the Special Date option is not available
    ● Previous Special Date: Compare and query data for the previous special date based on the current time
    ● Last week's same special date: Compare with the current time to query data for last week's same day. If last week's same day is a non special date, the special date option is not available`,
    },
};
locale.lang.ok = 'Confirm';
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
export default locale;
